// src/config/routes/public.routes.ts
import { lazy } from 'react';
import { RouteConfig } from 'src/types/route-config.types';

export const authRoutes: RouteConfig[] = [
    {
        name: "login",
        path: "/login",
        showInSideNav: false,
        access: ["*"], // Accessible to everyone
        component: lazy(() => import('src/pages/auth/login/LoaginPage')),
        breadcrumbPath: ["auth", "login"],
        icon: "signup",
        order: 2,
        meta: {
            title: "Create Your Account",
            description: "Join our platform and get started today",
        }
    },
]
